import FormWithRoles from './FormWithRoles'

const ADMIN = 'admin'
const MANAGER = 'manager'
const REGULAR = 'regular'
const SUPERVISOR = 'supervisor'

class UserForm extends FormWithRoles {
  static selector = '.edit_user, .new_user'

  constructor(form) {
    const checkBoxes = [
      { name: 'hasEdlus', visibleFor: role => [REGULAR, SUPERVISOR].includes(role) },
      { name: 'hasTasker', visibleFor: role => [REGULAR, SUPERVISOR].includes(role) },
      { name: 'hasScheduler', visibleFor: role => [REGULAR, SUPERVISOR].includes(role) }
    ]

    super({ form, checkBoxes, namespace: 'users' })

    const {
      syncAllUserGroupsCheck,
      hasEdlusInput,
      companiesManager,
      hasTaskerInput,
      taskCreator,
      roleInput,
      hasScheduler
    } = this.selectors

    if (syncAllUserGroupsCheck) {
      syncAllUserGroupsCheck.addEventListener('change', this.toggleUserGroupsVisibility)
    }

    if (hasEdlusInput && roleInput) {
      const toggleFn = this.buildToggleFn(hasEdlusInput, [companiesManager, hasScheduler])

      hasEdlusInput.addEventListener('change', toggleFn)
      roleInput.addEventListener('change', toggleFn)

      toggleFn()
    }

    if (hasTaskerInput && roleInput) {
      const toggleFn = this.buildToggleFn(hasTaskerInput, [taskCreator])

      hasTaskerInput.addEventListener('change', toggleFn)
      roleInput.addEventListener('change', toggleFn)

      toggleFn()
    }
  }

  bindElements() {
    this.selectors = {
      roleInput: this.form.querySelector('#user_role'),
      taskerUserGroupsContainer: this.form.querySelector('.user_tasker_user_groups'),
      syncAllUserGroupsCheck: this.form.querySelector('#user_sync_all_user_groups'),
      hasEdlusInput: this.form.querySelector('#user_has_edlus'),
      hasEdlus: this.form.querySelector('.user_has_edlus'),
      hasTaskerInput: this.form.querySelector('#user_has_tasker'),
      hasTasker: this.form.querySelector('.user_has_tasker'),
      hasScheduler: this.form.querySelector('.user_has_scheduler'),
      companiesManager: this.form.querySelector('.user_companies_manager'),
      taskCreator: this.form.querySelector('.user_task_creator')
    }
  }

  toggleUserGroupsVisibility = event => {
    const { taskerUserGroupsContainer } = this.selectors

    this.form.querySelectorAll('.rs__multi-value__remove').forEach(item => item.click())
    taskerUserGroupsContainer.classList[event.target.checked ? 'add' : 'remove']('d-none')
  }

  buildToggleFn = (parent, children) => () =>
    children.forEach(child => this.toggleVisibility(parent.checked, child.parentElement))

  toggleVisibility = (show, wrapper) =>
    !show || this.isManagerOrAdmin() ? wrapper.classList.add('d-none') : wrapper.classList.remove('d-none')

  isManagerOrAdmin = () => {
    return [ADMIN, MANAGER].includes(this.selectors.roleInput.value)
  }
}

export default UserForm
